module.exports = __webpack_public_path__ + "media/cases-brand-suning-lazyload-33.8126f114.mp4";